export const perPageValues = [10, 25, 50]

export default perPageValues
